<% var component = new Anvil.models.components.SelectSimple(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col<%- ('width' in field) ? `-${field.width}` : '' %>">
	<select class="form-select" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %>>
		<option value=""></option>
		<% if ('options' in field) for (let [key, value] of field.options) { %>
		<option value="<%= key %>" <% if (form.data[field.name] == key) { %>selected<% } %>><%= value %></option>
		<% } %>
	</select>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<select class="form-select" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %>>
			<option value=""></option>
			<% if ('options' in field) for (let [key, value] of field.options) { %>
			<option value="<%= key %>" <% if (form.data[field.name] == key) { %>selected<% } %>><%= value %></option>
			<% } %>
		</select>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
